import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Image,
  Flex,
  Box,
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
  Textarea,
  ModalHeader,
  useDisclosure,
  useToast,
  Text,
} from "@chakra-ui/react";
import { Field, Form, Formik, FormikErrors } from "formik";
import { useEffect, useState } from "react";

import PubContent from "./content";
import { ServerError } from "@/types/errors";
import { RiDeleteBinLine } from "@remixicon/react";
import SmrDeleteModal from "../deletemodal";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { useLazyGetContentQuery, useUpdateContentMutation } from "@/services/api/endpoints/content";
import Client4 from "@/services/api/client4";
import { selectCurrentImage, setCurrentImage } from "@/reducer/designslice";
import { contentRemove } from "@/reducer/contentSlice";
import { Content, ContentPub, ContentPublish } from "@/types/content";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  contentId: string;
};

const SmrPublish = (props: Props) => {
  const { isOpen, onClose, contentId } = props;

  const dispatch = useAppDispatch();
  const currentImage = useAppSelector(selectCurrentImage);

  const [getContent, { data }] = useLazyGetContentQuery()
  const [updateContent] = useUpdateContentMutation()
  
  const deleteControl = useDisclosure();
  const toast = useToast();

  useEffect(()=>{
    const fetchData = async()=>{
      if(props.isOpen){
        await getContent(props.contentId)
      }
    }
    fetchData()
  },[props.isOpen])


  const handleOnDelete = async () => {
    dispatch(contentRemove(contentId));
    Client4.deleteContent(contentId);
    if(currentImage.id === contentId){
      dispatch(setCurrentImage({} as Content ));
    }
    deleteControl.onClose();
    };

  const handleValidate = (values: ContentPublish) => {
    const errors: FormikErrors<ContentPub> = {};
    if (!values.content_name) {
      errors.content_name = "作品名称不能为空";
    }
    if (!values.content_intro) {
      errors.content_intro = "作品简介不能为空";
    }
    return errors;
  };
  const hanldeOnSubmit = async (values: ContentPublish) => {
    console.log(values);
    values.status = true;
    let res = await updateContent(values).unwrap().catch((e) => {
      toast({
        title: (e as ServerError).message,
        position: 'top',
        status: 'error',
        duration: 2000,
        isClosable: true,
      })
    })
    if(res){
      toast({
        title: "发布成功",
        position: 'top',
        status: 'success',
        duration: 2000,
        isClosable: true,
      })
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="6xl"
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent background="#161922">
        <ModalHeader color="#FFFFFF" fontSize={"18px"}>
          发布作品
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody>
          {data && (
            <Flex>
              <Flex
                padding="10px"
                flexDirection={"column"}
                bg="#0C0B10"
                borderRadius={"10px"}
                w="0"
                flex={1}
              >
                <Flex flex={1} alignItems={"center"} justifyContent={"center"}>
                  <Image src={data.image_url} />
                </Flex>
                <Flex justifyContent={"flex-end"}>
                  <Button
                    p="6px"
                    h="38px"
                    bg="#1E253F"
                    color={"#FFFFFF"}
                    fontSize="14px"
                    fontWeight={"normal"}
                    borderRadius={"4px"}
                    _hover={{
                      bg: "#303853",
                    }}
                    leftIcon={<RiDeleteBinLine color="#FFFFFF" size="16px" />}
                    onClick={deleteControl.onOpen}
                  >
                    删除
                  </Button>
                </Flex>
              </Flex>
              <Box
                p="20px"
                ml="20px"
                borderRadius={"10px"}
                border="1px dashed #6C7596"
                overflow="auto"
                maxHeight="600px"
                flex={1}
              >
                <Formik
                  initialValues={data}
                  onSubmit={hanldeOnSubmit}
                  validate={handleValidate}
                >
                  {({ submitForm, setFieldValue, values }) => (
                    <Form>
                      <Field name="content_name">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.content_name &&
                              form.touched.content_name
                            }
                            mt={"20px"}
                          >
                            <FormLabel fontSize={"14px"} color="#FFFFFF">
                              *作品名称
                            </FormLabel>
                            <Flex
                              bg="#0C0B10"
                              borderRadius="10px"
                              alignItems={"center"}
                              gap="10px"
                            >
                              <Input
                                flex={1}
                                {...field}
                                maxLength="32"
                                fontSize={"14px"}
                                color="#FFFFFF"
                                bg="#0C0B10"
                                border={"none"}
                                placeholder="请输入作品名称"
                                focusBorderColor="transparent"
                                _focus={{
                                  borderColor: "transparent",
                                }}
                              />
                              <Text fontSize={"14px"} color={"#6C7596"}>
                                {values.content_name.length}/32
                              </Text>
                            </Flex>

                            <FormErrorMessage>
                              {form.errors.content_name}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                      <Field name="content_intro">
                        {({ field, form }: any) => (
                          <FormControl
                            isInvalid={
                              form.errors.content_intro &&
                              form.touched.content_intro
                            }
                            mt={"20px"}
                            mb={"20px"}
                          >
                            <FormLabel fontSize={"14px"} color="#FFFFFF">
                              *作品简介
                            </FormLabel>
                            <Box bg="#0C0B10" borderRadius="10px">
                              <Textarea
                                placeholder="请输入作品简介"
                                {...field}
                                fontSize={"14px"}
                                color="#FFFFFF"
                                bg="#0C0B10"
                                border={"none"}
                                maxLength={300}
                                focusBorderColor="transparent"
                                _focus={{
                                  borderColor: "transparent",
                                }}
                              />
                              <Flex justifyContent={"flex-end"} p="5px">
                                <Text fontSize={"14px"} color={"#6C7596"}>
                                  {values.content_intro.length}/300
                                </Text>
                              </Flex>
                            </Box>

                            <FormErrorMessage>
                              {form.errors.content_intro}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                      <FormControl>
                        <FormLabel fontSize={"14px"} color="#FFFFFF">
                          创意详情
                        </FormLabel>
                        <PubContent pubContent={values} />
                      </FormControl>

                      {/* <Flex mt="20px">
                        {!values.status && (
                          <button type="submit" className="btn-grad">
                            发布
                          </button>
                        )}
                      </Flex> */}
                      {!values.status && (
                        <Flex mt="20px" justifyContent={"flex-end"}>
                          <Button
                            w="88px"
                            h="36px"
                            mr="15px"
                            bg="#1E253F"
                            color={"#FFFFFF"}
                            fontSize="14px"
                            fontWeight={"normal"}
                            borderRadius={"38px"}
                            _hover={{
                              bg: "#CBD1DF",
                              color: "#8E94A9",
                            }}
                            onClick={() => onClose()}
                          >
                            取消
                          </Button>
                          <Button
                            type="submit"
                            w="116px"
                            h="36px"
                            color={"#FFFFFF"}
                            fontSize="14px"
                            fontWeight={"normal"}
                            borderRadius={"38px"}
                            background={
                              "linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"
                            }
                            _hover={{
                              background:
                                "linear-gradient(90deg, #496AE1 0%, #66E8E0 100%)",
                            }}
                          >
                            发布作品
                          </Button>
                        </Flex>
                      )}
                    </Form>
                  )}
                </Formik>
              </Box>
            </Flex>
          )}
          {contentId && (
            <SmrDeleteModal
              isOpen={deleteControl.isOpen}
              onClose={deleteControl.onClose}
              onDelete={handleOnDelete}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SmrPublish;
